import { render, staticRenderFns } from "./NewAddressModal.vue?vue&type=template&id=6413597e&scoped=true&"
import script from "./NewAddressModal.vue?vue&type=script&lang=js&"
export * from "./NewAddressModal.vue?vue&type=script&lang=js&"
import style0 from "./NewAddressModal.vue?vue&type=style&index=0&id=6413597e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6413597e",
  null
  
)

export default component.exports